import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleSpinner } from '../../../actions/appAction';
import { usePageMessages } from '../../../hooks/selectors';
import ModalComponent from '../../utils/ModalComponent';
import { DangerouslyHtml } from '../DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from '../Layout/InfoPage/InfoPage';

const ReportProblemModal = (props) => {
    const { gotIt, reportProblemTitle, reportProblemSubtitle } = usePageMessages();

    return (
        <ModalComponent isVerticalCentered canCloseModal={false}>
            <InfoPage
                insideModalComponent
                iconName="check-rounded-thin"
                iconColor="purple"
                headerText={<DangerouslyHtml dangerouslyHtml={reportProblemTitle} />}
                secondaryText={<DangerouslyHtml dangerouslyHtml={reportProblemSubtitle} />}
                primaryButtonCaption={gotIt}
                primaryButtonType="button"
                primaryButtonOnClick={() => {
                    props.modalRef?.current?.close();
                }}
            />
        </ModalComponent>
    );
};
ReportProblemModal.propTypes = {
    modalRef: PropTypes.object.isRequired,
    notNowLink: PropTypes.string,
};

export default connect(null, { toggleSpinner })(ReportProblemModal);
